import { render, staticRenderFns } from "./component-i93jfna3.vue?vue&type=template&id=01b4bc93&scoped=true&"
import script from "./component-i93jfna3.vue?vue&type=script&lang=js&"
export * from "./component-i93jfna3.vue?vue&type=script&lang=js&"
import style0 from "./component-i93jfna3.vue?vue&type=style&index=0&id=01b4bc93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b4bc93",
  null
  
)

export default component.exports